import { Injectable } from '@angular/core';
import { Observable ,  BehaviorSubject } from 'rxjs';
import { LawNavItem } from '../models/models';

@Injectable()
export class NavService {
    public _lawNavItem: LawNavItem | null;
    public _lawNavItem$ = new BehaviorSubject<any>(null);

    constructor() {}

    setActiveNavItem(data: LawNavItem | null): void {
        this._lawNavItem = data;
        this._lawNavItem$.next(this._lawNavItem);
    }

    getActiveNavItem(): Observable<any> {
        return this._lawNavItem$.asObservable();
    }

}